__turbopack_context__.v({
  "bottom-text": "style-module-scss-module__k_ejQW__bottom-text",
  "component": "style-module-scss-module__k_ejQW__component",
  "full-screen": "style-module-scss-module__k_ejQW__full-screen",
  "hidden": "style-module-scss-module__k_ejQW__hidden",
  "mute-button": "style-module-scss-module__k_ejQW__mute-button",
  "primary-color": "style-module-scss-module__k_ejQW__primary-color",
  "primary-transform": "style-module-scss-module__k_ejQW__primary-transform",
  "secondary-color": "style-module-scss-module__k_ejQW__secondary-color",
  "secondary-transform": "style-module-scss-module__k_ejQW__secondary-transform",
  "tertiary-color": "style-module-scss-module__k_ejQW__tertiary-color",
  "tertiary-transform": "style-module-scss-module__k_ejQW__tertiary-transform",
  "video": "style-module-scss-module__k_ejQW__video",
  "wrapper": "style-module-scss-module__k_ejQW__wrapper",
});
